export default __webpack_public_path__ + "static/media/graphic_design.016220a8.png";